import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgExitRightLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M14 22a1 1 0 1 0 0-2c-2.7 0-4.69-.675-6.008-1.992S6 14.7 6 12s.675-4.69 1.992-6.008S11.3 4 14 4a1 1 0 1 0 0-2c-3.007 0-5.597.753-7.422 2.578S4 8.993 4 12s.753 5.597 2.578 7.422S10.993 22 14 22'
    />
    <path
      fill={props.color}
      d='M14.06 8.818a1 1 0 0 1 1.708-.707l3.182 3.182a1 1 0 0 1 0 1.414l-3.182 3.182a1 1 0 0 1-1.707-.707V13H9.757a1 1 0 1 1 0-2h4.304z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgExitRightLine)
export default ForwardRef
